/*
  Testimonial slider
*/
import 'flickity-fade';

export function testimonialSlider() {
  var cellAlignValue = '';

  if (matchMedia('screen and (max-width: 768px)').matches) {
    cellAlignValue = 'center';
  } else {
    cellAlignValue = 'left';
  }

  $('.testimonials-section.slider .testimonials-row').flickity({
    pageDots: false,
    prevNextButtons: true,
    wrapAround: true,
    cellAlign: cellAlignValue,
    fade: true,
  });

  $('.testimonials-section.slider').each(function () {
    $(this).find('.flickity-button').appendTo($(this).find('.flickity-button-wrp'));
  });
}